import { MAX_64_CHARACTERS } from "@/typings/formik"
import type { Language } from "@/modules/language/utils/languageUtils"
import { z } from "zod"
import { word } from "@/modules/core/utils/i18n"

export const TemplateFormCategoryValidationSchema = (_language: Language) =>
  z.object({
    name: z
      .string()
      .min(1, word("global.form.required"))
      .max(MAX_64_CHARACTERS, word("form.maximum.characters", { count: MAX_64_CHARACTERS })),
  })
